import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkupCallout = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M12.1398 5.94353H1.86766V16.6329H12.1398V5.94353ZM0 4V18.5764H14.0075V4H0Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.6088 14.967L24 20L19.6159 17.836L23.6088 14.967Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16.3716 11.7741H14.0075V9.83058H17.2463L22.1955 16.0108L20.7607 17.255L16.3716 11.7741Z",
			fill: "currentColor"
		})
	]
});
export default SvgMarkupCallout;
